import { render, staticRenderFns } from "./articulos-lista.vue?vue&type=template&id=bd0f1f04&scoped=true&"
import script from "./articulos-lista.vue?vue&type=script&lang=ts&"
export * from "./articulos-lista.vue?vue&type=script&lang=ts&"
import style0 from "./articulos-lista.vue?vue&type=style&index=0&id=bd0f1f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0f1f04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCheckbox,VCol,VIcon,VList,VListItemGroup,VRow,VSpacer,VSwitch})
